var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_300_10073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40039 12.0008C6.40039 11.6825 6.52682 11.3773 6.75186 11.1523C6.97691 10.9272 7.28213 10.8008 7.60039 10.8008C7.91865 10.8008 8.22388 10.9272 8.44892 11.1523C8.67396 11.3773 8.80039 11.6825 8.80039 12.0008C8.80039 12.319 8.67396 12.6243 8.44892 12.8493C8.22388 13.0744 7.91865 13.2008 7.60039 13.2008C7.28213 13.2008 6.97691 13.0744 6.75186 12.8493C6.52682 12.6243 6.40039 12.319 6.40039 12.0008ZM10.8004 12.0008C10.8004 11.6825 10.9268 11.3773 11.1519 11.1523C11.3769 10.9272 11.6821 10.8008 12.0004 10.8008C12.3187 10.8008 12.6239 10.9272 12.8489 11.1523C13.074 11.3773 13.2004 11.6825 13.2004 12.0008C13.2004 12.319 13.074 12.6243 12.8489 12.8493C12.6239 13.0744 12.3187 13.2008 12.0004 13.2008C11.6821 13.2008 11.3769 13.0744 11.1519 12.8493C10.9268 12.6243 10.8004 12.319 10.8004 12.0008ZM16.4004 10.8008C16.0821 10.8008 15.7769 10.9272 15.5519 11.1523C15.3268 11.3773 15.2004 11.6825 15.2004 12.0008C15.2004 12.319 15.3268 12.6243 15.5519 12.8493C15.7769 13.0744 16.0821 13.2008 16.4004 13.2008C16.7187 13.2008 17.0239 13.0744 17.2489 12.8493C17.474 12.6243 17.6004 12.319 17.6004 12.0008C17.6004 11.6825 17.474 11.3773 17.2489 11.1523C17.0239 10.9272 16.7187 10.8008 16.4004 10.8008Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_300_10073",
    x: -2,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_300_10073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_300_10073",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButton);
export default __webpack_public_path__ + "static/media/IconButton.360bd4e6b83473d2943dcf6794b6a910.svg";
export { ForwardRef as ReactComponent };